module.exports = __webpack_public_path__ + "img/1487793462.7599fe91.jpg";